import React from "react";
import { FormProvider } from "react-hook-form";
import { Edit } from "@refinedev/mui";

import { LandingForm } from "@modules/landings/components/LandingForm";
import { useLandingEditForm } from "./controller";

export const LandingEdit = React.memo(() => {
  const { methods, handleSubmit, mutateAsync, isPending, formLoading, id } =
    useLandingEditForm();

  return (
    <Edit
      recordItemId={id}
      saveButtonProps={{
        onClick: handleSubmit(mutateAsync as any),
        loading: isPending,
      }}
      isLoading={formLoading}
    >
      <FormProvider {...methods}>
        <LandingForm />
      </FormProvider>
    </Edit>
  );
});
